module.exports = __webpack_public_path__ + "assets/c36ac25eb106d3923b36a4fab4bca0f2.png";